import { FAQ_ENTRIES, type HelpFaqEntry } from "./faq";

function norm(s: string) {
  return s
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^\p{Letter}\p{Number}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}

// English comment: Very small deterministic FAQ matcher (keywords + title + token overlap).
export function searchFaq(query: string, locale: string) {
  const lang = locale === "pl" ? "pl" : "en";
  const q = norm(query);
  const qTokens = new Set(q.split(" ").filter(Boolean));
  const scored = FAQ_ENTRIES.map((entry) => {
    const title = norm(entry.title[lang]);
    const answer = norm(entry.answer[lang]);
    const keywords = entry.keywords[lang].map(norm);
    let score = 0;

    if (!q) return { entry, score: 0 };

    if (title.includes(q)) score += 80;
    if (answer.includes(q)) score += 25;

    for (const kw of keywords) {
      if (kw === q) score += 120;
      else if (kw.includes(q) || q.includes(kw)) score += 60;
    }

    for (const tok of qTokens) {
      if (title.includes(tok)) score += 10;
      if (answer.includes(tok)) score += 2;
      for (const kw of keywords) {
        if (kw.includes(tok)) score += 12;
      }
    }

    return { entry, score };
  })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score);

  return scored.map((x) => x.entry);
}

export function getFaqById(id: string): HelpFaqEntry | null {
  return FAQ_ENTRIES.find((e) => e.id === id) || null;
}
